import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Gray_Btn from "../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
import { useDispatch, useSelector } from "react-redux";
import {
  allDepartment,
  allNon_Confirming_Work_Status,
} from "../../../../../../features/admin/common/Slice";
import { FixIDS } from "../../../../../../utils/fixIDS";

const Filter = ({ setShow, reportgenerate, setSearchParams }) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();
  const [success, setSuccess] = useState(false);
  // ⏱ auto hide toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];
  const dispatch = useDispatch();
  const all_department = useSelector((state) => state.common.all_department);
  const all_status = useSelector(
    (state) => state.common.all_non_confirmin_work_status,
  );
  useEffect(() => {
    dispatch(allDepartment());
    dispatch(allNon_Confirming_Work_Status());
  }, [dispatch]);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveDownloadPermission = permissions?.includes(
    FixIDS.non_confirming_work_report.Report_Download,
  );

  const onSubmit = async (data) => {
    setSearchParams(data);
  };

  return (
    <section className="Sample_Report_Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12">
                  <div className="row g-1">
                    <div className="col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div border_div">
                        <Form.Label>Filter By:</Form.Label>
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-xxl-4 col-md-6 col-sm-6 col-12">
                              <Controller
                                control={control}
                                name="department_id"
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={all_department}
                                    placeholder="Department Type"
                                  />
                                )}
                              />
                            </div>

                            <div className="col-xxl-4 col-md-6 col-sm-6 col-12">
                              <Controller
                                control={control}
                                name="status_id"
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={all_status}
                                    placeholder="Status"
                                  />
                                )}
                              />
                            </div>
                            {/* 
                            <div className="col-xxl-4 col-md-6 col-sm-6 col-12">
                              <Form.Control
                                type="text"
                                placeholder="Certified Value"
                                {...register("certified_value", {
                                  // required: "Transaction ID is required",
                                })}
                              />
                            </div> */}
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xxl-4 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                      <div className="filter_div ">
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Start Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Start Date"
                                {...register("start_date", {
                                  // required: "Transaction ID is required",
                                  // validate: (value) => {
                                  //   const year = value.split("-")[0];
                                  //   if (year.length !== 4) {
                                  //     return "Year must be exactly 4 digits";
                                  //   }
                                  //   const selectedDate = new Date(value);
                                  //   const today = new Date();
                                  //   today.setHours(0, 0, 0, 0);
                                  //   if (selectedDate < today) {
                                  //     return "Past dates are not allowed";
                                  //   }
                                  //   return true;
                                  // },
                                })}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                              <Form.Label>End Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="End Date"
                                {...register("end_date", {
                                  // required: "Transaction ID is required",
                                  // validate: (value) => {
                                  //   const year = value.split("-")[0];
                                  //   if (year.length !== 4) {
                                  //     return "Year must be exactly 4 digits";
                                  //   }
                                  //   const selectedDate = new Date(value);
                                  //   const today = new Date();
                                  //   today.setHours(0, 0, 0, 0);
                                  //   if (selectedDate < today) {
                                  //     return "Past dates are not allowed";
                                  //   }
                                  //   return true;
                                  // },
                                })}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-12">
                  <div className="btns_holder">
                    {/* {success ? (
                    <Success_Toster successText="Report Generated Successfully!" />
                  ) : (
                    <> */}
                    <Gray_Btn
                      btnText="Reset"
                      onClick={() => {
                        setSearchParams({
                          start_date: "",
                          end_date: "",
                          status_id: null,
                          department_id: null,
                        });
                        reset({
                          start_date: "",
                          end_date: "",
                          status_id: null,
                          department_id: null,
                        });
                      }}
                    />
                    <Black_Submit_Btn
                      btnText="Search"
                      type="submit"
                      // onClick={() => setSuccess(true)}
                    />
                    {/* </>
                  )} */}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
        <div className="col-lg-2 p-0">
          {haveDownloadPermission && (
            <div className="add_sample_div" onClick={() => reportgenerate()}>
              <div className="add_img_div">
                <img
                  src="/assets/images/other/report.png"
                  className="add_img"
                />
              </div>
              <p className="inner_text">Generate Report</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Filter;
